module.exports = __webpack_public_path__ + "img/unknown.16e0d62.png";